import { useEffect, useState } from "react";
import axios from "axios";
import { ProtokollZeile } from "@/pages/Aenderungsprotokoll";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const TeilnehmerVerlauf = ({ teilnehmerId }) => {
  const [liste, setListe] = useState(null);
  useEffect(() => {
    axios.get(`${API}/aktivitaeten/teilnehmer/${teilnehmerId}`, { params: { limit: 100 } }).then((r) => setListe(r.data)).catch(() => setListe([]));
  }, [teilnehmerId]);
  if (!liste) return <p className="text-sm text-stone-500">Lade Verlauf …</p>;
  return (
    <ul className="divide-y divide-stone-200" data-testid="tn-verlauf">
      {liste.map((a) => <ProtokollZeile key={a.id} a={a} />)}
      {!liste.length && <li className="py-6 text-sm text-stone-500 text-center">Noch keine Änderungen protokolliert.</li>}
    </ul>
  );
};
